module.exports = __webpack_public_path__ + "static/img/album5_202601_02.30f3e1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/album5_202601_02.jpg
// module id = f5Vf
// module chunks = 98